module.exports = __webpack_public_path__ + "static/img/far2_active.4a23e2ca.png";